

import {
  EpaysageBaseSaveInput,
  EpaysageEssenceActionInput,
  InventaireResponse,
} from '@repo/types';
import { services } from '@repo/ui/lib/api/services';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

const INVENTORY_QUERY_KEY = ['inventaires'];
const EPAYSAGE_QUERY_KEY = ['epaysages'];

export function useSaveEpaysageBase(
  options?: UseMutationOptions<
    InventaireResponse,
    unknown,
    EpaysageBaseSaveInput,
    unknown
  >
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['epaysage', 'save-base'],
    mutationFn: (payload: EpaysageBaseSaveInput) =>
      services.epaysageInventory.saveBase(payload),
    onSuccess: (response, variables, context) => {
      queryClient.invalidateQueries({ queryKey: INVENTORY_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: EPAYSAGE_QUERY_KEY });
      // @ts-ignore
      options?.onSuccess?.(response, variables, context);
    },
    ...options,
  });
}

export function useMutateEpaysageEssence(
  options?: UseMutationOptions<
    InventaireResponse,
    unknown,
    EpaysageEssenceActionInput,
    unknown
  >
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['epaysage', 'essence'],
    mutationFn: (payload: EpaysageEssenceActionInput) =>
      services.epaysageInventory.mutateEssence(payload),
    onSuccess: (response, variables, context) => {
      queryClient.invalidateQueries({ queryKey: INVENTORY_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: EPAYSAGE_QUERY_KEY });
      // @ts-ignore
      options?.onSuccess?.(response, variables, context);
    },
    ...options,
  });
}

